export default __webpack_public_path__ + "static/media/no_message.75d4363f.svg";